export const SET_VITALS_VALUES = 'VitalsContext.SET_VITALS_VALUES';
export const RESET_VITALS_VALUES = 'VitalsContext.RESET_VITALS_VALUES';
export const SET_MEASURE_FIELDS = 'VitalsContext.SET_MEASURE_FIELDS';
export const SET_VITALS_NAMES = 'VitalsContext.SET_VITALS_NAMES';
export const RESET_VITALS_NAMES = 'VitalsContext.RESET_VITALS_NAMES';
export const SET_UNITS_VALUES = 'VitalsContext.SET_UNITS_VALUES';
export const RESET_UNITS_VALUES = 'VitalsContext.RESET_UNITS_VALUES';
export const SET_COMMENTS_VALUES = 'VitalsContext.SET_COMMENTS_VALUES';
export const RESET_COMMENTS_VALUES = 'VitalsContext.RESET_COMMENTS_VALUES';
export const SET_DISABLE_VITALS = 'VitalsContext.SET_DISABLE_VITALS';
export const SET_LOADER = 'VitalsContext.SET_LOADER';
export const SET_ERRORS = 'VitalsContext.SET_ERRORS';
